import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Calendar, ArrowRight } from "lucide-react";
import api from "@/lib/api";

const FALLBACK = [
  { id: "1", slug: "knee-pain-causes", title: "5 Common Causes of Knee Pain in Adults", excerpt: "From osteoarthritis to ligament tears — understanding what's behind chronic knee pain.", category: "Joint Pain", cover_url: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=900", created_at: "2024-11-05" },
  { id: "2", slug: "post-surgery-nutrition", title: "Best Foods for Faster Bone Healing", excerpt: "Calcium, vitamin D, protein — a dietitian-backed guide to recovery nutrition.", category: "Nutrition", cover_url: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=900", created_at: "2024-10-22" },
  { id: "3", slug: "arthritis-exercises", title: "Safe Exercises for Arthritis Patients", excerpt: "Stay mobile without flaring up joint pain. Try these physician-approved movements.", category: "Exercise", cover_url: "https://images.unsplash.com/photo-1540205895360-4ad4cffb3aa8?w=900", created_at: "2024-10-08" },
];

export default function Blog() {
  const [items, setItems] = useState(FALLBACK);
  useEffect(()=>{ api.get("/blogs").then(({data})=>{ if(data?.length) setItems(data.filter(b=>b.published!==false)); }).catch(()=>{}); },[]);
  return (
    <main className="pt-32 pb-16" data-testid="blog-page">
      <div className="container-x">
        <motion.div initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{duration:0.6}}>
          <span className="overline">Health Library</span>
          <h1 className="font-heading text-5xl sm:text-6xl tracking-tight font-light mt-3">Insights from the <em className="italic font-medium text-primary">specialist</em></h1>
        </motion.div>
        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {items.map((b,i)=>(
            <motion.article key={b.id} initial={{opacity:0,y:20}} whileInView={{opacity:1,y:0}} viewport={{once:true}} transition={{duration:0.5,delay:i*0.06}}
              className="group bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-soft hover:shadow-medium transition-shadow" data-testid={`blog-card-${b.slug}`}>
              <div className="aspect-[16/10] overflow-hidden bg-slate-100">
                {b.cover_url && <img src={b.cover_url} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/>}
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-xs text-slate-500"><span className="px-2 py-0.5 rounded-full bg-primary/8 text-primary uppercase tracking-wider">{b.category}</span><span className="flex items-center gap-1"><Calendar className="w-3 h-3"/>{(b.created_at||"").slice(0,10)}</span></div>
                <h3 className="mt-3 font-heading text-xl font-medium leading-snug">{b.title}</h3>
                <p className="mt-2 text-sm text-slate-500 leading-relaxed">{b.excerpt}</p>
                <Link to={`/blog/${b.slug}`} className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary">Read more <ArrowRight className="w-4 h-4"/></Link>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </main>
  );
}
